'use client';

import { useState, useTransition } from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@kit/ui/alert';
import { Button } from '@kit/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@kit/ui/form';
import { Input } from '@kit/ui/input';
import { Textarea } from '@kit/ui/textarea';
import { Trans } from '@kit/ui/trans';

import { ContactEmailSchema } from '~/(marketing)/contact/_lib/contact-email.schema';
import { sendContactEmail } from '~/(marketing)/contact/_lib/server/server-actions';

export function NewsletterForm() {
  const { t } = useTranslation();

  return (
    <form
      method="post"
      action="https://t396266d7.emailsys1a.net/282/510/db223af4fe/subscribe/form.html?_g=1739362701"
      target="_blank"
      className="nrf-marketing-form"
    >
      <div className="flex w-full flex-col space-y-3 sm:flex-row sm:space-x-6 sm:space-y-0">
        <div className="flex-grow">
          <Input
            type="email"
            name="email"
            id="email"
            placeholder="E-Mail"
            className="text-black"
            required
          />
        </div>
        <div>
          <Button
            type="submit"
            variant={'outline'}
            size="lg"
            className="w-full border-white text-white sm:w-auto"
          >
            Subscribe
          </Button>
        </div>
      </div>
    </form>
  );
}
